import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {createStore} from 'redux';
import {Provider} from 'react-redux';
import {appReducer} from './reducers';
import LocalizationMisc from './miscs/LocalizationMisc';

const store = createStore(
  appReducer,
  (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()
);

const initialize = async () => {
  const config = await axios.get('/user/config');
  const {oo_host, host, ovs_host} = config.data;
  try {
    const token = new URLSearchParams(window.location.search).get('token');
    if (token)  {
      try {
        const {data} = await axios({
          url: (oo_host || 'http://localhost') + '/auth/refresh',
          method: 'GET',
          headers: {
            authorization: `JWT ${token}`
          }
        });
        localStorage.setItem('credentials', JSON.stringify(data))
      } catch (err) {
        console.log(err);
        window.location.href = (oo_host || `http://lh.omnicomm.ru`) + `?redirect=${host || 'http://localhost:9912'}`
      }
    }
    const credentials = localStorage.getItem('credentials');
    if (!credentials) {
       window.location.href = (oo_host || `http://lh.omnicomm.ru`) + `?redirect=${host || 'http://localhost:9912'}`
    } else {
      const {jwt, refresh} = JSON.parse(credentials);
      try {
        const {data} = await axios({
          url: (oo_host || `http://lh.omnicomm.ru`) + `/auth/refresh`,
          method: 'GET',
          headers: {
            authorization: `JWT ${refresh}`
          }
        });
        localStorage.setItem('credentials', JSON.stringify(data));
        let lang = new URLSearchParams(window.location.search).get('lang');
        if (!lang) {
          lang = localStorage.getItem('lang');
        } else {
          localStorage.setItem('lang', lang)
        }
        const local = await axios.get(`/user/local?lang=${lang || 'ru'}`, {headers: {
            authorization: `JWT ${jwt}`
          }});
        LocalizationMisc.setLocal( 'streaming', local.data );
      } catch (err) {
        window.location.href = (oo_host || `http://lh.omnicomm.ru`) + `?redirect=${host || 'http://localhost:9912'}`
      }
    }

    ReactDOM.render(
      <Provider store={store}>
        <App/>
      </Provider>
    , document.getElementById('root'));
  } catch (e) {
    console.error( e.message );
  }
}

initialize();


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
